import React from 'react';

import { color as colors } from 'src/shared/styles/variables';

export const ThumbIcon = ({ color = colors.baliHai }) => (
    <svg width="22px" height="20px" viewBox="0 0 22 20">
        <g
            id="thumb"
            transform="translate(-799.000000, -837.000000)"
            fill={color}
            fill-rule="nonzero"
        >
            <g id="Group-2" transform="translate(70.000000, 742.000000)">
                <g id="ic_thumb_up_24px-copy-2" transform="translate(729.000000, 95.000000)">
                    <path
                        d="M0,20 L4,20 L4,8 L0,8 L0,20 Z M22,9 C22,7.9 21.1,7 20,7 L13.69,7 L14.64,2.43 L14.67,2.11 C14.67,1.7 14.5,1.32 14.23,1.05 L13.17,0 L6.59,6.59 C6.22,6.95 6,7.45 6,8 L6,18 C6,19.1 6.9,20 8,20 L17,20 C17.83,20 18.54,19.5 18.84,18.78 L21.86,11.73 C21.95,11.5 22,11.26 22,11 L22,9.09 L21.99,9.08 L22,9 Z"
                        id="Shape"
                    />
                </g>
            </g>
        </g>
    </svg>
);
